
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { NavigationMenu, NavigationMenuItem, NavigationMenuList, NavigationMenuTrigger } from "@/components/ui/navigation-menu";
import { useTheme } from '@/contexts/ThemeContext';
import { useQuery } from '@tanstack/react-query';
import contentfulService from '@/services/contentfulService';
import { BookOpen, Video, Music } from 'lucide-react';
import StoriesMenu from './menu/StoriesMenu';
import VideosMenu from './menu/VideosMenu';

const MegaMenu = () => {
  const navigate = useNavigate();
  const { resolvedTheme } = useTheme();
  
  const {
    data: stories = [],
    isLoading
  } = useQuery({
    queryKey: ['stories'],
    queryFn: contentfulService.getStories
  });

  // Theme-based styles
  const textColor = resolvedTheme === 'dark' ? 'text-white' : 'text-foreground';
  const triggerBg = resolvedTheme === 'dark' 
    ? 'bg-transparent hover:bg-[#EAFEEB] hover:text-black focus:bg-[#EAFEEB] focus:text-black data-[state=open]:bg-[#EAFEEB] data-[state=open]:text-black' 
    : 'bg-transparent hover:bg-[#EAFEEB] focus:bg-[#EAFEEB] data-[state=open]:bg-[#EAFEEB]';

  // Define shared menu props
  const menuProps = {
    menuBg: resolvedTheme === 'dark' ? 'bg-netflix-black' : 'bg-background',
    menuText: resolvedTheme === 'dark' ? 'text-white/70' : 'text-foreground/70',
    menuHeaderText: resolvedTheme === 'dark' ? 'text-white' : 'text-foreground',
    menuItemText: resolvedTheme === 'dark' ? 'text-white/90 hover:text-white' : 'text-foreground/90 hover:text-foreground',
    hoverBg: resolvedTheme === 'dark' ? 'bg-white/5' : 'bg-foreground/5',
    borderColor: resolvedTheme === 'dark' ? 'border-white/10' : 'border-foreground/10',
    dividerColor: resolvedTheme === 'dark' ? 'border-white/10' : 'border-foreground/10',
    viewAllText: resolvedTheme === 'dark' ? 'text-white hover:text-white/80' : 'text-foreground hover:text-foreground/80'
  };

  return (
    <NavigationMenu className="w-full">
      <NavigationMenuList className="w-full justify-center">
        <NavigationMenuItem>
          <NavigationMenuTrigger 
            className={`${triggerBg} ${textColor} focus:${textColor} data-[state=open]:${textColor} flex items-center font-chroma`}
            onClick={() => navigate('/browse')}
          >
            <BookOpen className="mr-2" size={18} />
            Articles
          </NavigationMenuTrigger>
          <StoriesMenu 
            stories={stories}
            isLoading={isLoading}
            {...menuProps}
          />
        </NavigationMenuItem>

        <NavigationMenuItem>
          <NavigationMenuTrigger 
            className={`${triggerBg} ${textColor} focus:${textColor} data-[state=open]:${textColor} flex items-center font-chroma`}
            onClick={() => navigate('/videos')}
          >
            <Video className="mr-2" size={18} />
            Videos
          </NavigationMenuTrigger>
          <VideosMenu {...menuProps} />
        </NavigationMenuItem>

        <NavigationMenuItem>
          <button 
            className={`${triggerBg} ${textColor} flex items-center font-chroma h-10 w-max rounded-md px-4 py-2 text-sm hover:bg-[#EAFEEB]`}
            onClick={() => navigate('/playlists')}
          >
            <Music className="mr-2" size={18} />
            Playlists
          </button>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
};

export default MegaMenu;
